import {
    Box,
    Button,
    Chip,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Drawer,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Toolbar,
    Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import {DataGrid} from '@mui/x-data-grid';
import {useEffect, useMemo, useState} from 'react';
import LoadingContent from '../../../components/LoadingContent';
import {useApp} from '../../../context/AppContext';
import {useFetch} from '../../../hooks/useFetch';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import {useNavigate, useSearchParams} from 'react-router-dom';
import ProfileForm from '../components/UserForm';
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import {useFormik} from 'formik';
import useHandleErrors from '../../../hooks/useHandleErrors';
import lodash from 'lodash';
import EditUser from '../components/EditUser';

export default props => {
    const [addNew, setAddNew] = useState(false);
    const [editUser, setEditUser] = useState();
    const [filterView, setFilterView] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const {handleChange, handleSubmit, values, setValues, setFieldValue, handleReset} = useFormik({
        initialValues: {
            status: '',
            customer_name: '',
            profile_name: '',
            datetime: '',
        },
        onSubmit: values => {
            setFilterView(false);
            setSearchParams({...lodash.omitBy(values, v => v === '')}); //, status: values.status, delivery_status: values.delivery_status
        },
    });
    useEffect(() => {
        if (Boolean(searchParams)) {
            let toFields = Object.fromEntries(searchParams);
            toFields.datetime = searchParams.getAll('datetime') || undefined;
            setValues(toFields, false);
        }
    }, [searchParams]);

    const {data, error, mutate, isFetching} = useFetch('person', {params: searchParams});
    useHandleErrors(error);

    console.log(data)

    const columns = useMemo(() => [
        {
            field: 'id',
            headerName: 'ID',
            width: 70,
        },
        {
            field: 'name',
            headerName: 'Nome',
            minWidth: 300,
            flex: 1,
        },
        // {
        //     field: 'meetings',
        //     headerName: 'Encontros',
        //     width: 120,
        //     align: 'center',
        //     valueGetter: ({row}) => row.profile?.meeting.length,
        // },

        // {
        //     field: 'Team',
        //     headerName: 'Função',
        //     width: 150,
        //     align: 'center',
        //     valueGetter: ({value}) => value?.name || '--',
        //     // renderCell: ({value}) => (
        //     //     <Chip label={value} />
        //     // ),
        // },
        // {
        //     field: 'approved',
        //     headerName: 'Situação',
        //     width: 120,
        //     align: 'center',
        //     valueGetter: ({row}) => (row.profile?.approved ? 'Aprovado' : 'Não aprovado'),
        //     renderCell: ({row, value}) =>
        //         Boolean(row.profile) ? (
        //             <Chip label={value} color={value === 'Aprovado' ? 'success' : 'error'} />
        //         ) : (
        //             '-'
        //         ),
        // },

        {
            field: 'actions',
            type: 'actions',
            renderCell: ({row}) => (
                <Button
                    variant="outlined"
                    onClick={() => {
                        setEditUser(row);
                        setAddNew(true);
                    }}
                    size="small"
                    style={{fontSize: 10}}>
                    Detalhes
                </Button>
            ),
        },
    ]);

    if(isFetching) return <CircularProgress />
    if(error) return <Typography>{error.message}</Typography>


    return (
        <>
            <Container fixed>
                <Stack direction="row" width="100%" justifyContent="space-between" my={3}>
                    <Typography variant="h5" component="h2">
                        Usuários
                    </Typography>

                    <Stack direction="row" alignItems="center" columnGap={2}>
                        <Button variant="contained" onClick={e => setAddNew(true)}>
                            Adicionar novo
                        </Button>
                        {/* <Button variant="contained" onClick={e => setFilterView(true)}>
                            Filtros
                        </Button> */}
                    </Stack>
                </Stack>

                <Grid container sx={{height: 500}}>
                    <DataGrid
                        paginationMode="server"
                        loading={isFetching}
                        autoPageSize
                        rows={data || []}
                        columns={columns}
                    />
                </Grid>
            </Container>
            <Dialog
                fullWidth
                maxWidth="sm"
                open={addNew}
                scroll="paper"
                onClose={e => setAddNew(false)}>
                <DialogTitle>
                    Dados do usuário
                    <IconButton
                        aria-label="close"
                        onClick={e => setAddNew(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme => theme.palette.grey[500],
                        }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                {editUser? <EditUser mutate={mutate} data={editUser} close={e => setAddNew(false)} />: <ProfileForm close={e => setAddNew(false)} />}
                
            </Dialog>
            <Drawer
                anchor="right"
                variant="temporary"
                open={filterView}
                onClose={e => setFilterView(false)}>
                <Toolbar>
                    <Typography variant="h6">Filtros</Typography>
                    <Divider />
                </Toolbar>
                <Box sx={{width: 350, p: 3}}>
                    <Grid container direction="column" spacing={2}>
                        <Grid item xs>
                            <TextField
                                fullWidth
                                name="name"
                                InputProps={{
                                    maxLength: 14,
                                }}
                                label="Nome do usuário"
                                value={values.name}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs>
                            <Button variant="contained" onClick={handleSubmit}>
                                Aplicar filtros
                            </Button>
                            <Button
                                onClick={e => {
                                    handleReset();
                                    handleSubmit();
                                }}>
                                Limpar filtros
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Drawer>
        </>
    );
};
